import axios from 'axios';
/* 获取地点 */
export function queryVendorSite (orgId, vendorCode) {
    return axios.post('/gscint/hw/ispInvoice/queryVendorSite', {
        orgId,
        vendorCode
    });
}

/* 币种 */
export function queryCurrencyCode (orgId, vendorCode) {
    return axios.post('/gscint/hw/ispInvoice/queryCurrencyCode', {
        orgId,
        vendorCode
    });
}